import {
  BulletCarousel,
  Grid,
  NewTypography as Typography,
  useViewport,
} from '@lamimed/pantheon';

import { NextSectionButton } from 'templates/AboutUs/containers/NextSectionButton/index';

import { ContentDivider } from 'components/ContentDivider';
import { SectionWrapper } from 'components/wrappers/SectionWrapper';

import { members } from './data';

import * as S from './styles';

interface Props {
  sectionToScroll: string;
}

export const ScientificCommitee = ({ sectionToScroll }: Props) => {
  const { greaterThan } = useViewport();

  return (
    <SectionWrapper id="scientific-comitee">
      <Grid.Wrapper>
        <Typography variant="heading_2" color="text__primary" as="h2">
          Il Comitato Scientifico
        </Typography>

        <Typography marginBottom={greaterThan('tablet') ? 'large' : 'medium'}>
          Un&apos;equipe medica multidisciplinare ci guida nella definizione e
          nella validazione dei protocolli medico-scientifici e
          nell&apos;individuazione delle soluzioni più innovative.
        </Typography>

        <BulletCarousel
          adaptiveHeight
          arrowSize={greaterThan('tablet') ? '3.2rem' : '1.8rem'}
          cellSpacing={20}
        >
          {members.map(({ name, description, credentials, image }) => (
            <S.DoctorCard key={name}>
              <S.DoctorProfile>
                <S.DoctorImage
                  src={image}
                  alt={`${name} photo`}
                  width={86}
                  height={86}
                  quality={100}
                />

                <S.DoctorDescription>
                  <Typography variant="heading_3" as="h3">
                    {name}
                  </Typography>

                  <Typography
                    variant="heading_5"
                    as="h5"
                    color="neutral"
                    marginBottom="none"
                  >
                    {description}
                  </Typography>
                </S.DoctorDescription>
              </S.DoctorProfile>

              <ContentDivider color="light" />

              <S.DoctorCredentials>
                {credentials.map((credential) => (
                  <S.Item key={credential}>{credential}</S.Item>
                ))}
              </S.DoctorCredentials>
            </S.DoctorCard>
          ))}
        </BulletCarousel>
      </Grid.Wrapper>

      <NextSectionButton nextSectionId={sectionToScroll} />
    </SectionWrapper>
  );
};

export default ScientificCommitee;
